angular.module('app').directive('apLoginBackground',
    [
        function () {
            'use strict';
        function link(scope, element) {
            scope.$watch('clientId', function (clientId) {
                element.css('background-image', 'url(images/login-background-clientId-' + clientId + '.jpg), url(images/login-background.jpg)');
            });
        }

        return {
            restrict: 'EA',
            scope: {
                clientId: '=clientId'
            },
            link: link

        };
    }]);